import React from 'react';
import {
  Link
} from 'react-router-dom';

/* Footer component */
const Footer = () => (
  <div className="app-footer">
    <footer className="container">
      <span className="pull-left"> &copy; 2017 BinaryOptions. All rights reserved.</span> 
      <span className="pull-right"><Link to="/contact">Terms</Link></span> 
    </footer>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js